module.exports = __webpack_public_path__ + "assets/58c953933c04eed0164b837ddc2bf3bb.png";